<template>
  <div class="inquary" v-loading="loading">
    <div class="inquary-title">お問い合わせ入力フォーム</div>

    <!-- 送信後：フォームを非表示にしてメッセージのみ表示（スタイルは既存classを流用） -->
    <div v-if="sent">
      <div class="app-form resultMsg">
        {{ resultMsg }}
      </div>
    </div>

    <!-- 送信前：既存フォーム（見た目はそのまま） -->
    <el-form v-else ref="inquaryForm" :model="form" class="app-form" :rules="rules">
      <h1>担当者情報</h1>
      <el-form-item label="氏名" prop="name">
        <el-input v-model="form.name" autocomplete="off" maxlength="64" placeholder="64文字以内"></el-input>
      </el-form-item>
      <el-form-item label="メールアドレス" prop="email">
        <el-input v-model="form.email" autocomplete="off" maxlength="64" placeholder="xxx@xxx.xxx"></el-input>
      </el-form-item>
      <el-form-item label="電話番号" prop="tel">
        <el-input v-model="form.tel" maxlength="11" placeholder="半角数字（ハイフンなし）"></el-input>
      </el-form-item>
      <el-form-item label="所属" prop="affiliationType">
        <el-select v-model="form.affiliationType" placeholder="選択してください">
          <el-option label="管理会社" value="管理会社"></el-option>
          <el-option label="管理組合" value="管理組合"></el-option>
          <el-option label="その他" value="その他"></el-option>
        </el-select>
      </el-form-item>
      <h1>物件情報</h1>
      <el-form-item label="マンション/アパート名称" prop="manshonName">
        <el-input v-model="form.manshonName" autocomplete="off" maxlength="64" placeholder="64文字以内"></el-input>
      </el-form-item>
      <el-form-item label="分譲・賃貸区分" prop="ownershipType">
        <el-select v-model="form.ownershipType" placeholder="選択してください">
          <el-option label="分譲" value="分譲"></el-option>
          <el-option label="賃貸" value="賃貸"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="ペット共生可・不可" prop="petAllowed">
        <el-select v-model="form.petAllowed" placeholder="選択してください">
          <el-option label="可" value="可"></el-option>
          <el-option label="不可" value="不可"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="住居数" prop="unitCount">
        <el-input v-model="form.unitCount" maxlength="9" ></el-input>
      </el-form-item>
      <h1>お問い合わせ内容</h1>
      </br>
      <el-form-item label="" prop="inquaryContent">
        <el-input
          type="textarea"
          v-model="form.inquaryContent"
          :autosize="{ minRows: 10, maxRows: 50 }"
          autocomplete="off"
          placeholder="2000文字以内"
          maxlength="2000">
        </el-input>
      </el-form-item>
      <br>
      <el-form-item>
        <table width="100%">
          <tr>
            <td width="25%"></td>
            <td width="50%"></td>
            <td width="25%">
              <el-button type="warning" @click="onSubmit">
                送信
              </el-button>
            </td>
          </tr>
        </table>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from '@/utils/request';

export default {
  name: 'Inquary',
  data() {
    return {
      loading: false,

      // 送信後表示用
      sent: false,
      resultMsg: '',

      submitting: false,
      logoPreview: '',
      logoImgUrl: '',
      form: {
        name: '',
        email: '',
        tel: '',
        affiliationType: '',
        manshonName: '',
        ownershipType: '',
        managementType: '',
        petAllowed: '',
        unitCount: '',
        inquaryContent: ''
      },
      rules: {
        name: [{ required: true, message: '必須です。', trigger: 'blur' }],
        email: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: '有効なメールアドレスを入力してください。', trigger: 'blur' }
        ],
        tel: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^[0-9]{1,11}$/, message: '半角数字（ハイフンなし）で入力してください。', trigger: 'blur' }
        ],
        affiliationType: [{ required: true, message: '必須です。', trigger: 'blur' }],
        manshonName: [{ required: true, message: '必須です。', trigger: 'blur' }],
        ownershipType: [{ required: true, message: '必須です。', trigger: 'blur' }],
        managementType: [{ required: true, message: '必須です。', trigger: 'blur' }],
        petAllowed: [{ required: true, message: '必須です。', trigger: 'blur' }],
        unitCount: [
          { required: true, message: '必須です。', trigger: 'blur' },
          { pattern: /^[0-9]+$/, message: '半角数字で入力してください。', trigger: 'blur' }
        ],
        inquaryContent: [{ required: true, message: '必須です。', trigger: 'blur' }]
      }
    };
  },

  methods: {
    // 送信ボタン押下
    async onSubmit() {
      try {
        // バリデーションチェック
        const isValid = await new Promise((resolve) => {
          this.$refs.inquaryForm.validate((valid) => resolve(valid));
        });
        if (!isValid) return false;

        // フォームデータ作成
        const formData = new FormData();
        Object.entries(this.form).forEach(([key, value]) => {
          formData.append(key, value == null ? '' : value);
        });

        // フォームデータ送信
        this.loading = true;
        const res = await request('inquary', formData);

        // 送信後：画面はメッセージのみ表示
        this.resultMsg = res.msg;
        this.sent = true;

      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="less">
  h1 {
    padding: 0.25em 0.5em;
    color: #494949;
    background: transparent;
    border-left: solid 5px #7db4e6;
    font: inherit;
    font-size: 16px;
  }
  .inquary {
    margin: 10px auto;
    max-width: 900px;
    .inquary-title {
      text-align: center;
      font-size: 28px;
      font-weight: bold;
      margin: 16px 0 24px 0;
    }
    overflow-x: hidden;
    overflow-x: clip; 
    width: 100%;
  }

  .resultMsg {
    white-space: pre-line;
    overflow-wrap: anywhere;
    word-break: break-word;
    max-width: 100%;
  }

  html, body {
    overflow-x: hidden;
    width: 100%;
  }

</style>
